import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import * as Actions from '../redux/keywordActions';
import * as Selectors from '../redux/keywordSelectors';
import KeywordForm from '../form/KeywordForm';
import { KeywordValues, KeywordParams } from '../model/keywordModel';
import { ROUTES } from '../../../core/router/routes';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

const breadcrumbs = [
  {
    label: 'keyword.edit',
    to: null,
  },
];

let disableSuccessSnackbarAction = true;

const KeywordEdit: React.FC = () => {
  const params = useParams<KeywordParams>();
  const dispatch = useDispatch();
  const initialValues = useSelector(Selectors.initialValues);
  const history = useHistory();
  const apiRequestState = useSelector(Selectors.apiKeywordRequestState);
  const apiRequestError = useSelector(Selectors.apiKeywordRequestError);
  const { show, hide } = useMainProgressContext();

  useEffect(() => {
    dispatch(Actions.getKeyword(params));
  }, [params]);

  useEffect(() => {
    if (initialValues.name.length && apiRequestState !== API_REQUEST_STATE.LOADING) {
      hide();
    }
  }, [initialValues]);

  useEffect(
    () => () => {
      dispatch(Actions.resetKeyword());
    },
    [],
  );

  return (
    <>
      <SnackbarSettings
        disableSuccessAction={disableSuccessSnackbarAction}
        successMessage="keyword.snackbar.edit_success"
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiKeywordRequestState}
        onSuccess={() => {
          history.push(ROUTES.KEYWORD.LIST);
        }}
      />
      <KeywordForm
        breadcrumbs={breadcrumbs}
        title="keyword.edit"
        initialValues={initialValues}
        onSubmit={(values: KeywordValues) => {
          show();
          disableSuccessSnackbarAction = false;
          dispatch(Actions.editKeyword(params, values));
        }}
      />
    </>
  );
};

export default KeywordEdit;
